var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoMb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 157,
    height: 64,
    viewBox: "0 0 157 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_2501_3500)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.16403 7H18.9241L20.0723 8.14824V13.3974L18.9241 14.5456L20.0723 15.6938V20.943L18.9241 22.0912H9.16403L9 18.6465H9.57412V10.4447H9L9.16403 7ZM14.1671 10.4447V13.3153L15.4794 12.8232V10.4447H14.1671ZM14.1671 16.7601V18.6465H15.4794V16.268L14.1671 16.7601Z",
    fill: "url(#paint0_linear_2501_3500)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4903 7H45.2504L45.4144 12.3311H41.9697L41.8057 10.4447H40.4934V13.3153L41.8057 12.8232V16.268L40.4934 16.7601V18.6465H41.0675L40.9035 22.0912H35.4903L35.3263 18.6465H35.9004V10.4447H35.3263L35.4903 7Z",
    fill: "url(#paint1_linear_2501_3500)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.148 7H47.388L47.2239 10.4447H47.7981V18.6465H47.2239L47.388 22.0912H52.8011L52.9652 18.6465H52.391V16.7601L53.7033 16.268V12.8232L52.391 13.3153V10.4447H53.7033L53.8673 12.3311H57.3121L57.148 7Z",
    fill: "url(#paint2_linear_2501_3500)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.4408 16.268L64.1285 16.7601V18.6465H64.3745L64.2105 22.0912H59.1254L58.9614 18.6465H59.5355V8.14824L60.6838 7H68.8855L70.0337 8.14824V18.6465H70.6079L70.4438 22.0912H65.3587L65.1947 18.6465H65.4408V16.268ZM64.1285 13.3153L65.4244 12.8232V10.4447H64.1285V13.3153Z",
    fill: "url(#paint3_linear_2501_3500)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.9901 7H72.5769L72.4129 10.4447H72.987V18.6465H72.4129L72.5769 22.0912H82.337L82.501 16.7601H79.0563L78.8923 18.6465H77.58V10.4447H78.1541L77.9901 7Z",
    fill: "url(#paint4_linear_2501_3500)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.4588 7H93.6441L94.7924 8.14824H94.8088V20.943L93.6605 22.0912H85.4588L84.3105 20.943V8.14824L85.4588 7ZM88.9035 18.6465H90.2158V10.4447H88.9035V18.6465Z",
    fill: "url(#paint5_linear_2501_3500)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.473 30.583C146.159 30.1115 142.783 29.0898 142.783 29.0898L143.411 28.0788C142.341 28.2441 141.515 28.3771 140.271 28.9973L140.27 28.9976C140.27 28.9978 140.269 28.998 140.269 28.9983L140.268 28.9987L140.268 28.9989C138.248 30.0562 137.268 31.0609 136.952 31.9267C136.888 32.104 136.85 32.2749 136.838 32.4397C136.789 33.0857 137.118 33.6311 137.63 34.0311C138.333 34.5817 139.381 34.8588 140.271 34.7473C140.271 34.7473 138.622 36.3189 136.267 35.5331C135.459 35.2394 134.807 34.6791 134.373 33.9794C132.706 31.2883 133.721 26.9358 138.658 25.1026C138.658 25.1026 131.948 14.631 122.998 10.8593L108.708 15.1028L110.514 16.36L99.5219 20.1317L100.386 20.682L82.9553 28.3037C82.9553 28.3037 83.8192 31.9182 80.1289 36.6336C80.1289 36.6336 82.6417 36.3189 85.4681 31.7614C85.4681 31.7614 83.6621 40.8767 77.6161 41.5053L75.4368 54H83.1309L81.8905 51.7126C81.8905 51.7126 81.3358 47.7058 81.5409 47.3208C82.0646 46.3384 82.5881 46.1747 84.5653 45.5562C84.9608 45.4325 85.4145 45.2906 85.938 45.1203C86.5733 44.9136 87.2665 44.8033 88.0117 44.6849C90.9499 44.2178 94.6964 43.6222 98.8926 36.4768C98.8926 36.4768 98.0288 40.72 96.9296 42.056C99.4416 41.82 101.562 45.4346 101.562 45.4346L110.723 45.2128L109.57 36.4768L113.297 46.285L116.178 46.2478L120.469 53.9996L126.843 53.9208L124.787 51.6427L123.389 46.6918L126.768 45.5214L128.414 48.3417L129.278 46.2199L131.947 51.2492L133.203 49.2058C133.203 49.2058 137.993 51.4847 138.778 51.4847C139.563 51.4847 146.629 43.234 148.042 38.7554C148.042 38.7554 146.786 31.0549 146.472 30.5826L146.473 30.583ZM140.205 41.7671C140.205 41.7671 139.427 42.405 138.658 41.8188C138.658 41.8188 138.678 42.1392 138.42 42.4721C138.42 42.4721 137.813 39.7843 138.735 38.9436C138.735 38.9436 140.397 39.7775 140.928 42.4293C140.928 42.4293 140.566 41.7598 140.205 41.7671Z",
    fill: "url(#paint6_linear_2501_3500)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5444 45.7978C88.5444 45.7978 92.2189 45.7295 93.8089 44.0792V44.0788L98.1075 51.5636L100.856 53.9997L92.801 53.6498L88.5444 45.7978Z",
    fill: "url(#paint7_linear_2501_3500)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.351 46.7339V53.9997H112.731L111.093 51.6424L111.167 46.7339H105.351Z",
    fill: "url(#paint8_linear_2501_3500)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.288 7.16403H22.0388L21.8748 10.6088H22.4489V20.943L23.5972 22.0912H31.7989L32.9472 20.943V10.6088H33.5213L33.3572 7.16403H28.1081L27.9441 10.6088H28.3542V18.6465H27.0419V10.6088H27.452L27.288 7.16403Z",
    fill: "url(#paint9_linear_2501_3500)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.7725 24.3124H56.216L55.8933 34.7999H61.2178L61.5404 31.0889H63.4766V47.2235H62.3472L62.6699 54H73.3187L73.6414 47.2235H72.512V31.0889H74.4481L74.7708 34.7999H80.0952L79.7725 24.3124Z",
    fill: "url(#paint10_linear_2501_3500)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7789 24.3124H52.979L53.3017 34.7999H46.5252L46.2025 31.0889H43.621V36.736L46.2025 35.7679V42.5445L43.621 43.5125V47.2235H46.2025L46.5252 43.5125H53.3017L52.979 54H33.7789L33.4562 47.2235H34.5856V31.0889H33.4562L33.7789 24.3124Z",
    fill: "url(#paint11_linear_2501_3500)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6196 24.3124H9.4195L9.09681 31.0889H10.2262V47.2235H9.09681L9.4195 54H28.6196L30.8785 51.7412V41.415L28.6196 39.1562L30.8785 36.8974V26.5712L28.6196 24.3124ZM19.2616 36.736V31.0889H21.8431V35.7679L19.2616 36.736ZM19.2616 47.2235V43.5125L21.8431 42.5445V47.2235H19.2616Z",
    fill: "url(#paint12_linear_2501_3500)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_2501_3500",
    x: 0.862745,
    y: 0.490196,
    width: 155.317,
    height: 63.2745,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.62745
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.06863
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2501_3500"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2501_3500",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.813725
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "overlay",
    in2: "shape",
    result: "effect2_innerShadow_2501_3500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2501_3500",
    x1: 78.5211,
    y1: 7,
    x2: 78.5211,
    y2: 54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2501_3500",
    x1: 78.5211,
    y1: 7,
    x2: 78.5211,
    y2: 54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2501_3500",
    x1: 78.5211,
    y1: 7,
    x2: 78.5211,
    y2: 54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2501_3500",
    x1: 78.5211,
    y1: 7,
    x2: 78.5211,
    y2: 54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2501_3500",
    x1: 78.5211,
    y1: 7,
    x2: 78.5211,
    y2: 54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2501_3500",
    x1: 78.5211,
    y1: 7,
    x2: 78.5211,
    y2: 54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2501_3500",
    x1: 78.5211,
    y1: 7,
    x2: 78.5211,
    y2: 54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2501_3500",
    x1: 78.5211,
    y1: 7,
    x2: 78.5211,
    y2: 54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2501_3500",
    x1: 78.5211,
    y1: 7,
    x2: 78.5211,
    y2: 54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2501_3500",
    x1: 78.5211,
    y1: 7,
    x2: 78.5211,
    y2: 54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2501_3500",
    x1: 78.5211,
    y1: 7,
    x2: 78.5211,
    y2: 54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2501_3500",
    x1: 78.5211,
    y1: 7,
    x2: 78.5211,
    y2: 54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2501_3500",
    x1: 78.5211,
    y1: 7,
    x2: 78.5211,
    y2: 54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMb);
export default ForwardRef;